import { useTranslate } from "@tolgee/react";
import { useLocation } from "@tanstack/react-router";
import { LocalizedLink } from "#/components/locale/localized-link";
import { NAV_LINKS } from "./nav-links";

export function DesktopNav() {
	const { t } = useTranslate();
	const { pathname } = useLocation();
	const isTradeActive = pathname.startsWith("/trade/");
	return (
		<div className="hidden items-center gap-10 text-body2-bold md:flex">
			{NAV_LINKS.map((link) => (
				<LocalizedLink
					key={link.to}
					to={link.to}
					className={
						link.to === "/trade" && isTradeActive
							? "nav-link is-active"
							: "nav-link"
					}
					activeProps={{ className: "nav-link is-active" }}
				>
					{t(link.labelKey)}
				</LocalizedLink>
			))}
		</div>
	);
}
